import { render, staticRenderFns } from "./ServiceAppElin.vue?vue&type=template&id=59c84d4e&scoped=true&"
import script from "./ServiceAppElin.vue?vue&type=script&lang=js&"
export * from "./ServiceAppElin.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAppElin.vue?vue&type=style&index=0&id=59c84d4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c84d4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
